export const initialValues = {
  date: new Date().toISOString().split('T')[0], // Set today's date in YYYY-MM-DD format
  historyDate: new Date().toISOString().split('T')[0],
  vitals: {
    systolicBP: '',
    diastolicBP: '',
    heartRate: '',
    fastingBloodSugar: '',
    postPrandialBloodSugar: '',
    randomBloodSugar: '',
    postPrandialBloodSugarType: '',
    randomBloodSugarType: '',
    hba1c: '',
    height: '',
    weight: '',
    bmi: '',
    waistCircumference: ''
  },
  history: {
    diabetes: false,
    hypertension: false,
    copd: false,
    ckd: false,
    liverFailure: false,
    pvd: false,
    heartAttack: false,
    stroke: false,
    heartDisease: false,
    diabetesVerified: false,
    hypertensionVerified: false,
    copdVerified: false,
    ckdVerified: false,
    liverFailureVerified: false,
    pvdVerified: false,
    heartAttackVerified: false,
    strokeVerified: false,
    heartDiseaseVerified: false,
    pregnant: '',
    familyHistory: {
      prematureMI: '',
      stroke: '',
      diabetes: ''
    },
    tobaccoConsumption: {
      smokesTobacco: '',
      smokelessTobacco: ''
    },
    alcoholConsumption: ''
  },
  currentMedication: '',
  currentMedicationDate: new Date().toISOString().split('T')[0],
  medications: [],
  symptomsDate: new Date().toISOString().split('T')[0],
  symptoms: {
    general: {
      excsThirst: null,
      excsUrinatn: null,
      excsHunger: null,
      recrntSkin: null,
      woundHeal: null,
      dietChng: null,
      visualDistrbnc: null,
      breathlsns: null,
      angina: null,
      claudicatn: null,
      limpness: null
    },
    oral: {
      ulcer: null,
      cavityPatch: null,
      diffOpngMouth: null,
      spicyFood: null,
      voiceChange: null,
      other: ''
    },
    breast: {
      lump: null,
      dischrg: null,
      retrctn: null,
      othr: ''
    },
    cervical: {
      bldDrngPrd: null,
      bldBtwnPrd: null,
      postMeno: null,
      coitalBld: null,
      foulSmell: null,
      othr: ''
    },
    oralNone: false,
    breastNone: false,
    cervicalNone: false
  },
  physicalExamination: ''
};
